// ........................................Candidate Start..............................

// src/redux/types.js
export const FETCH_GENDERS_REQUEST = "FETCH_GENDERS_REQUEST";
export const FETCH_GENDERS_SUCCESS = "FETCH_GENDERS_SUCCESS";
export const FETCH_GENDERS_FAILURE = "FETCH_GENDERS_FAILURE";
export const SET_SELECTED_GENDER = "SET_SELECTED_GENDER";

// ........................................Company Start..............................

// Industry Types
export const FETCH_INDUSTRY_REQUEST = 'FETCH_INDUSTRY_REQUEST';
export const FETCH_INDUSTRY_SUCCESS = 'FETCH_INDUSTRY_SUCCESS';
export const FETCH_INDUSTRY_FAILURE = 'FETCH_INDUSTRY_FAILURE';
export const SET_SELECTED_INDUSTRY = 'SET_SELECTED_INDUSTRY';

// Companycat Types
export const FETCH_COMPANY_CATEGORIES_REQUEST = 'FETCH_COMPANY_CATEGORIES_REQUEST';
export const FETCH_COMPANY_CATEGORIES_SUCCESS = 'FETCH_COMPANY_CATEGORIES_SUCCESS';
export const FETCH_COMPANY_CATEGORIES_FAILURE = 'FETCH_COMPANY_CATEGORIES_FAILURE';
export const SET_SELECTED_COMPANY_CATEGORY = 'SET_SELECTED_COMPANY_CATEGORY';

// CompanySize Types
export const FETCH_COMPANY_SIZE_REQUEST = 'FETCH_COMPANY_SIZE_REQUEST';
export const FETCH_COMPANY_SIZE_SUCCESS = 'FETCH_COMPANY_SIZE_SUCCESS';
export const FETCH_COMPANY_SIZE_FAILURE = 'FETCH_COMPANY_SIZE_FAILURE';
export const SET_SELECTED_COMPANY_SIZE = 'SET_SELECTED_COMPANY_SIZE';

// ........................................Company End.................................

// ........................................Recruiter Start.................................

// Industry Recruiter Types
export const FETCH_INDUSTRY_REC_REQUEST = 'FETCH_INDUSTRY_REC_REQUEST';
export const FETCH_INDUSTRY_REC_SUCCESS = 'FETCH_INDUSTRY_REC_SUCCESS';
export const FETCH_INDUSTRY_REC_FAILURE = 'FETCH_INDUSTRY_REC_FAILURE';
export const SET_SELECTED_REC_INDUSTRY = 'SET_SELECTED_REC_INDUSTRY';



// Recruiter Cat Types
export const FETCH_COMPANY_CATEGORY_REC_REQUEST = 'FETCH_COMPANY_CATEGORY_REC_REQUEST';
export const FETCH_COMPANY_CATEGORY_REC_SUCCESS = 'FETCH_COMPANY_CATEGORY_REC_SUCCESS';
export const FETCH_COMPANY_CATEGORY_REC_FAILURE = 'FETCH_COMPANY_CATEGORY_REC_FAILURE';
export const SET_SELECTED_COMPANY_REC_CATEGORY = 'SET_SELECTED_COMPANY_REC_CATEGORY';

// Recruiter Size Types
export const FETCH_COMPANY_SIZE_REC_REQUEST = 'FETCH_COMPANY_SIZE_REC_REQUEST';
export const FETCH_COMPANY_SIZE_REC_SUCCESS = 'FETCH_COMPANY_SIZE_REC_SUCCESS';
export const FETCH_COMPANY_SIZE_REC_FAILURE = 'FETCH_COMPANY_SIZE_REC_FAILURE';
export const SET_SELECTED_COMPANY_REC_SIZE = 'SET_SELECTED_COMPANY_REC_SIZE';

// ........................................Recruiter End.................................

// .........................................User Type Start....................................
export const FETCH_USER_TYPE_REC_REQUEST = 'FETCH_USER_TYPE_REC_REQUEST';
export const FETCH_USER_TYPE_REC_SUCCESS =  'FETCH_USER_TYPE_REC_SUCCESS';
export const FETCH_USER_TYPE_REC_FAILURE = 'FETCH_USER_TYPE_REC_FAILURE';
export const SET_USER_COMPANY_REC_TYPE = 'SET_USER_COMPANY_REC_TYPE';
// .........................................User Type End....................................


// Work Level Types
// export const FETCH_WORKLEVEL_TYPE_REQUEST = 'FETCH_WORKLEVEL_TYPE_REQUEST';
// export const FETCH_WORKLEVEL_TYPE_SUCCESS = 'FETCH_WORKLEVEL_TYPE_SUCCESS';
// export const FETCH_WORKLEVEL_TYPE_FAILURE = 'FETCH_WORKLEVEL_TYPE_FAILURE';
// export const SET_WORKLEVEL_COMPANY_TYPE = 'SET_WORKLEVEL_COMPANY_TYPE';
export const FETCH_WORKLEVEL_TYPE_REQUEST = 'FETCH_WORKLEVEL_TYPE_REQUEST';
export const FETCH_WORKLEVEL_TYPE_SUCCESS = 'FETCH_WORKLEVEL_TYPE_SUCCESS';
export const FETCH_WORKLEVEL_TYPE_FAILURE = 'FETCH_WORKLEVEL_TYPE_FAILURE';
export const SET_WORKLEVEL_COMPANY_TYPE = 'SET_WORKLEVEL_COMPANY_TYPE';
export const SELECT_WORKLEVEL = 'SELECT_WORKLEVEL';



// Work Location Types
export const FETCH_WORKLOCATION_TYPE_REC_REQUEST = 'FETCH_WORKLOCATION_TYPE_REC_REQUEST';
export const FETCH_WORKLOCATION_TYPE_REC_SUCCESS = 'FETCH_WORKLOCATION_TYPE_REC_SUCCESS';
export const FETCH_WORKLOCATION_TYPE_REC_FAILURE = 'FETCH_WORKLOCATION_TYPE_REC_FAILURE';
export const SET_WORKLOCATION_COMPANY_REC_TYPE = 'SET_WORKLOCATION_COMPANY_REC_TYPE';


// City Types
export const FETCH_CITY_REQUEST = 'FETCH_CITY_REQUEST';
export const FETCH_CITY_SUCCESS = 'FETCH_CITY_SUCCESS';
export const FETCH_CITY_FAILURE = 'FETCH_CITY_FAILURE';
export const SET_SELECTED_CITY = 'SET_SELECTED_CITY';

// Job Category Types
export const FETCH_JOBCATEGORY_REQUEST = 'FETCH_JOBCATEGORY_REQUEST';
export const FETCH_JOBCATEGORY_SUCCESS = 'FETCH_JOBCATEGORY_SUCCESS';
export const FETCH_JOBCATEGORY_FAILURE = 'FETCH_JOBCATEGORY_FAILURE';
export const SET_SELECTED_JOBCATEGORY = 'SET_SELECTED_JOBCATEGORY';


// Job Type Types
export const FETCH_JOBTYPE_REQUEST = 'FETCH_JOBTYPE_REQUEST';
export const FETCH_JOBTYPE_SUCCESS = 'FETCH_JOBTYPE_SUCCESS';
export const FETCH_JOBTYPE_FAILURE = 'FETCH_JOBTYPE_FAILURE';
export const SET_SELECTED_JOBTYPE = 'SET_SELECTED_JOBTYPE';

// salary Type Types
export const FETCH_SALARYTYPE_REQUEST = 'FETCH_SALARYTYPE_REQUEST';
export const FETCH_SALARYTYPE_SUCCESS = 'FETCH_SALARYTYPE_SUCCESS';
export const FETCH_SALARYTYPE_FAILURE = 'FETCH_SALARYTYPE_FAILURE';
export const SET_SELECTED_SALARYTYPE = 'SET_SELECTED_SALARYTYPE';

// designationTypes
export const FETCH_DESIGNATION_REQUEST = 'FETCH_DESIGNATION_REQUEST';
export const FETCH_DESIGNATION_SUCCESS = 'FETCH_DESIGNATION_SUCCESS';
export const FETCH_DESIGNATION_FAILURE = 'FETCH_DESIGNATION_FAILURE';
export const SET_SELECTED_DESIGNATION = 'SET_SELECTED_DESIGNATION';

// skill Types
export const FETCH_SKILL_REQUEST = 'FETCH_SKILL_REQUEST';
export const FETCH_SKILL_SUCCESS = 'FETCH_SKILL_SUCCESS';
export const FETCH_SKILL_FAILURE = 'FETCH_SKILL_FAILURE';
export const SET_SELECTED_SKILL = 'SET_SELECTED_SKILL';

// country Types
export const FETCH_COUNTRY_REQUEST = 'FETCH_COUNTRY_REQUEST';
export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';
export const FETCH_COUNTRY_FAILURE = 'FETCH_COUNTRY_FAILURE';
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';

// .................................................................
// Search Types
export const FETCH_GETINSTITUTE_REQUEST = 'FETCH_GETINSTITUTE_REQUEST';
export const FETCH_GETINSTITUTE_SUCCESS = 'FETCH_GETINSTITUTE_SUCCESS';
export const FETCH_GETINSTITUTE_FAILURE = 'FETCH_GETINSTITUTE_FAILURE';
export const SET_SELECTED_GETINSTITUTE = 'SET_SELECTED_GETINSTITUTE';

// GetCompanies Types
export const FETCH_GETCOMPANIES_REQUEST = 'FETCH_GETCOMPANIES_REQUEST';
export const FETCH_GETCOMPANIES_SUCCESS = 'FETCH_GETCOMPANIES_SUCCESS';
export const FETCH_GETCOMPANIES_FAILURE = 'FETCH_GETCOMPANIES_FAILURE';
export const SET_SELECTED_GETCOMPANIES = 'SET_SELECTED_GETCOMPANIES';

// GetAllOrgs Types
export const FETCH_GETALLORGS_REQUEST = 'FETCH_GETALLORGS_REQUEST';
export const FETCH_GETALLORGS_SUCCESS = 'FETCH_GETALLORGS_SUCCESS';
export const FETCH_GETALLORGS_FAILURE = 'FETCH_GETALLORGS_FAILURE';
export const SET_SELECTED_GETALLORGS = 'SET_SELECTED_GETALLORGS';

// GetOrgTypes Types
export const FETCH_GETORGSTYPES_REQUEST = 'FETCH_GETORGSTYPES_REQUEST';
export const FETCH_GETORGSTYPES_SUCCESS = 'FETCH_GETORGSTYPES_SUCCESS';
export const FETCH_GETORGSTYPES_FAILURE = 'FETCH_GETORGSTYPES_FAILURE';
export const SET_SELECTED_GETORGSTYPES = 'SET_SELECTED_GETORGSTYPESS';


// GetSpeciallization Types
export const FETCH_GETSPECIALIZATION_REQUEST = 'FETCH_GETSPECIALIZATION_REQUEST';
export const FETCH_GETSPECIALIZATION_SUCCESS = 'FETCH_GETSPECIALIZATION_SUCCESS';
export const FETCH_GETSPECIALIZATION_FAILURE = 'FETCH_GETSPECIALIZATION_FAILURE';
export const SET_SELECTED_GETSPECIALIZATION = 'SET_SELECTED_GETSPECIALIZATION';

// GetQualification Types
export const FETCH_GETQUALIFICATION_REQUEST = 'FETCH_GETQUALIFICATION_REQUEST';
export const FETCH_GETQUALIFICATION_SUCCESS = 'FETCH_GETQUALIFICATION_SUCCESS';
export const FETCH_GETQUALIFICATION_FAILURE = 'FETCH_GETQUALIFICATION_FAILURE';
export const SET_SELECTED_GETQUALIFICATION = 'SET_SELECTED_GETQUALIFICATION';

// LANGUAGE Types
export const FETCH_LANGUAGE_REQUEST = 'FETCH_LANGUAGE_REQUEST';
export const FETCH_LANGUAGE_SUCCESS = 'FETCH_LANGUAGE_SUCCESS';
export const FETCH_LANGUAGE_FAILURE = 'FETCH_LANGUAGE_FAILURE';
export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';